import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-[400px]">
        {/* Logo */}
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold tracking-tight text-foreground">
            MedTechOS
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Clinical Data Management Platform
          </p>
        </div>

        {/* Card */}
        <div className="rounded-lg border border-border bg-card p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
